<template>
    <div v-if="mapReady" ref="propertyMap" class="max-vh-100" :style="`height:${styleHeight}`"></div>
</template>

<script type="text/javascript">
    /*global google*/
    import MapConfig from '@/config/maps.json';

    import ApiObject from '@/classes/ApiObject.js';
    import CommonComponents from '@/components/Common.vue';
    import GoogleMaps from '@/classes/Google/Maps/Maps.js';
    import Api from '@/classes/Api.js';

    export default {
        components: {
            ...CommonComponents,
        },
        
        data() {
            return {
                mapReady: false,
                mapCreated: false,
                error: null,
                disposed: false,
            };
        },

        emits: ['update'],

        async mounted() {
            if (await Api.isOnline(true)) {
                this.mapReady = await GoogleMaps.ready();
            }

            // track the markers to dispose them
            // none reactive
            // this.marker;
            // ths.map;
        },

        beforeUnmount() {
            this.disposed = true;

            if (this.mapCircle) {
                this.mapCircle.setMap(null);
                delete this.mapCircle;
            }
            delete this.map;
        },

        watch: {
            async mapReady() {
                this.createMap();
            }
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
            
            height: {
                type: [Number, String],
                default: 500
            },
        },

        computed: {
            styleHeight() {
                if (typeof this.height == 'string') {
                    return this.height;
                }
                return this.height+'px';
            },
        },

        methods: {
            async createMap() {
                if (
                    (this.mapCreated) ||
                    (this.disposed) ||
                    (!this.property.publicLat) ||
                    (!this.property.publicLng)
                ) return;

                if (
                    (!this.$refs.propertyMap) ||
                    (!window.google) ||
                    (!window.google.maps)
                ) {
                    setTimeout(this.createMap, 250);
                    return;
                }
                
                this.mapCreated = true;

                let mapOptions = {
                    center: new google.maps.LatLng(this.property.publicLat, this.property.publicLng),
                    zoom: 13,
                    maxZoom: 17,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    disableDefaultUI: true,
                    styles: MapConfig.styles.frontEnd,
                    scrollwheel: false,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL,
                        position: google.maps.ControlPosition.RIGHT_BOTTOM
                    },
                    mapTypeControlOptions: {
                        position: google.maps.ControlPosition.BOTTOM_LEFT
                    }
                };
                
                if (!this.$refs.propertyMap) {
                    return;
                }
                this.map = new google.maps.Map(this.$refs.propertyMap, mapOptions);

                let circleShape = {
                    ...MapConfig.shapes.general.default,
                    map: this.map,
                    center: new google.maps.LatLng(this.property.publicLat, this.property.publicLng),
                    radius: 700, // ~ 1 mile
                }

                this.mapCircle = new google.maps.Circle(circleShape);

            },
        },
    };

</script>
